package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
//import androidx.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateColumns
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.px

val CandidaturesTextStyle = CssStyle {
    base {
        // Mobile par défaut
        Modifier.fontSize(20.px)
    }
    Breakpoint.MD {
        // Desktop / Tablette
        Modifier.fontSize(26.px)
    }
}
val CreateDocumentCardTextStyle = CssStyle {
    base          { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(18.px) }
}
val SpanTextStylecss = CssStyle {
    base          { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(20.px) }
}
val TextStyleCss = CssStyle {
    base          { Modifier.fontSize(16.px) }
    Breakpoint.MD { Modifier.fontSize(20.px) }
}
val SpanStyleCSS = CssStyle {
    base          { Modifier.fontSize(20.px) }
    Breakpoint.MD { Modifier.fontSize(26.px) }
}
val CreateCardStylecss = CssStyle {
    base {
        // Mobile par défaut
        Modifier
            .width(140.px)
            .height(185.px)
    }
    Breakpoint.MD {
        // Desktop / Tablette
        Modifier
            .width(280.px)
            .height(380.px)
    }
}
val CreateCardSpantextStylecss = CssStyle {
    base {
        // Mobile par défaut
        Modifier
            .width(140.px)
    }
    Breakpoint.MD {
        // Desktop / Tablette
        Modifier
            .width(280.px)
    }
}
val SearchButtonResponsiveStyle = CssStyle {
    base {
        Modifier
            .margin(top = 0.px)
            .padding(leftRight = 20.px)
            .fillMaxWidth()
    }
    Breakpoint.MD {
        Modifier
            .margin(top = 19.px)
            .padding(leftRight = 28.px)
            .styleModifier { property("width", "auto") }
    }
}
val DashboardContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.PriceGray)
            .padding(
                top = 20.px,
                bottom = 20.px,
                leftRight = 16.px
            )
    }

    Breakpoint.LG {
        Modifier
            .padding(
                top = 32.px,
                bottom = 0.px,
                leftRight = 40.px
            )
    }
}
val DashboardMainContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.PriceGray)
            .padding(
                top = 20.px,
                bottom = 20.px,
                left = 16.px,
                right = 25.px
            )
    }

    Breakpoint.LG {
        Modifier
            .padding(
                top = 32.px,
                bottom = 0.px,
                left = 40.px,
                right = 120.px
            )
    }
}

val DashboardGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Grid)
            .gridTemplateColumns { repeat(1) { size(1.fr) } } // 1 seule colonne sur mobile
            .gap(32.px)
    }
    Breakpoint.MD {
        Modifier
            .gridTemplateColumns { repeat(2) { size(1.fr) } } // 2 colonnes sur Desktop
    }
}
val DesktopOnlyStyle = CssStyle {
    base          { Modifier.display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.display(DisplayStyle.Flex) }
}

val MobileOnlyStyle = CssStyle {
    base          { Modifier.display(DisplayStyle.Flex) }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
}

// Style CSS responsive pour le formulaire
val SearchFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .gap(10.px)
    }
    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .alignItems(AlignItems.FlexEnd)
            .gap(12.px)
    }
}

// Style pour que les champs prennent 100% en mobile et se partagent l'espace en desktop
val SearchFieldWrapperStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
    Breakpoint.MD {
        Modifier
            .fillMaxWidth(0.px) // Réinitialise la largeur fixe pour laisser le flex-grow agir
            .flex(1)            // Équivalent CSS de flex: 1 (flex-grow: 1)
    }
}